import { INQUIRY_MESSAGE_MAX_LENGTH } from './inquiryPackageModel';

export const INQUIRY_BLOCK_SIGN_IN = 'sign-in';
export const INQUIRY_BLOCK_UNVERIFIED = 'unverified';
export const INQUIRY_BLOCK_SESSION = 'session';
export const INQUIRY_BLOCK_MESSAGE = 'message';

export const isInquiryEmailUnverified = user =>
  Boolean(user?.id) && user.attributes?.emailVerified === false;

export const canSendInquiry = user => Boolean(user?.id) && user.attributes?.emailVerified === true;

export const hasSavedInquiryDraft = values => {
  const message = typeof values?.message === 'string' ? values.message.trim() : '';
  const dates = values?.bookingDates || {};
  return Boolean(message || dates.startDate || dates.endDate);
};

// A user id is not permission to send. Email must be verified, and a user
// object that has not finished loading must not be treated as signed out or
// as verified.
export const inquirySubmitBlock = (user, message) => {
  if (!user?.id) {
    return INQUIRY_BLOCK_SIGN_IN;
  }
  if (user.attributes?.emailVerified === false) {
    return INQUIRY_BLOCK_UNVERIFIED;
  }
  if (user.attributes?.emailVerified !== true) {
    return INQUIRY_BLOCK_SESSION;
  }
  if (typeof message === 'string' && message.length > INQUIRY_MESSAGE_MAX_LENGTH) {
    return INQUIRY_BLOCK_MESSAGE;
  }
  return null;
};

export const tryBeginInquirySubmit = lock => {
  if (!lock || lock.current) {
    return false;
  }
  lock.current = true;
  return true;
};

export const endInquirySubmit = lock => {
  if (lock) {
    lock.current = false;
  }
};

// Login and signup forms render inside the inquiry form. A submit that
// originated on an inner form must not send the inquiry.
export const isNestedFormSubmit = event =>
  Boolean(event && event.target && event.currentTarget && event.target !== event.currentTarget);
